module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Kf-Lb.d76867ce.png";